import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  standalone: true,
  selector: 'atom-landing-fifth-content-item',
  imports: [CommonModule],
  templateUrl: './landing-fifth-content-item.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
      :host .blue-500 {
        color: rgba(101, 111, 203, 1);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingFifthContentItemAtom {
  @Input() item = {
    number: '1',
    content: 'eheheh',
    srcImg: '/frontend-assets/images/Group 15.webp',
  };




}
